<template>
	<div>
		<Popup
			v-model:show="followModify"
			round
			position="bottom"
			closeable
			:close-on-click-overlay="false"
			:style="{ height: '300px' }"
		>
			<div style="width: 100%;height: 100%;position: relative;">
				<div style="font-size: var(--base-px-14);font-weight: bold;text-align: center;padding-top: var(--base-px-15);">
					修改跟进
				</div>
				<Divider/>
				<div class="newly_row" v-if="modifyInfo.processTemplateName">
					<div style="color: #999;">
						模板记录：{{ modifyInfo.processTemplateName }}
					</div>
				</div>
				<div class="add_follow_page">
					<div class="text-box">
            <textarea
	            class="textarea"
	            placeholder="请输入要添加的跟进信息吧，添加成功后将出现在客户动态列表里~"
	            v-model="modifyInfo.content"
            ></textarea>
					</div>
				</div>
				<div class="foot_row">
					<van-button type="primary" block @click="addProcessEvent">修改</van-button>
				</div>
			</div>
		</Popup>
	</div>
</template>
<script>
import {Divider, Popup, Toast} from 'vant'
import dropDownCase from '@/components/dropDownCase/dropDownCase'
// eslint-disable-next-line no-unused-vars
import {ContactFollowApi} from '@/api/contactFollow'

export default {
	components: {Popup, Divider, Toast, dropDownCase},
	data() {
		return {
			followModify: false,
			// 备注内容
			content: '',
			modifyInfo: {}
		}
	},
	methods: {
		// 获取跟进详情
		getFollowInfo() {
			ContactFollowApi.infoApi({
				targetId: this.targetId
			}).then((res) => {
				this.modifyInfo = res.data
			})
		},
		// 修改
		addProcessEvent() {
			ContactFollowApi.updateApi({
				trackId: this.trackId,
				targetId: this.targetId,
				content: this.modifyInfo.content
			}).then((res) => {
				Toast('修改成功')
				this.followModify = false
				this.$emit('change', true)
			})
		},
		show(obj) {
			this.followModify = true
			this.trackId = obj.id
			this.targetId = obj.content.target_id
			// this.event = obj.event
			this.getFollowInfo()
		}
	}
}
</script>
<style scoped lang="less">
.text-box {
	display: flex;
	justify-content: center;
	margin-top: var(--base-px-45);
	border: var(--base-px-1) solid #eee;
}

.textarea {
	//border: 0;
	background: none;
	outline: none;
	border: none;
	height: var(--base-px-200);
	width: 100%;
	padding: var(--base-px-20) var(--base-px-30) var(--base-px-20) var(--base-px-30);
	font-size: var(--base-px-26);
	resize: none;
}

.add_follow_flex {
	display: flex;
	justify-content: space-between;
}

.add_follow_page {
	font-size: var(--base-px-26);
	padding: 0 var(--base-px-35);
}

.newly_row {
	margin-top: var(--base-px-20);
	font-size: var(--base-px-26);
	padding: 0 var(--base-px-50) 0 var(--base-px-50);
}

.foot_row {
	width: calc(100% - var(--base-px-80));
	position: absolute;
	bottom: var(--base-px-30);
	left: var(--base-px-40);
}

.add_input {
	width: var(--base-px-100);
	margin-left: var(--base-px-5);
	margin-right: var(--base-px-5);
	border: var(--base-px-1) solid #D9D9D9;
	height: var(--base-px-40);
}

.newly_input {
	border: var(--base-px-1) solid #D9D9D9;
	margin-left: var(--base-px-15);
	padding-left: var(--base-px-10);
	height: var(--base-px-50);
}

.input_style {
	padding-left: var(--base-px-10);
	height: var(--base-px-50);
	border: var(--base-px-1) solid #D9D9D9;
}

.option_row {
	width:  var(--base-px-270);
	height: var(--base-px-50);
	border: var(--base-px-1) solid #cccccc;
	position: relative;
}

.option_row select {
	position: absolute;
	top: 0;
	/*清除select的边框样式*/
	border: none;
	/*清除select聚焦时候的边框颜色*/
	outline: none;
	/*将select的宽高等于div的宽高*/
	width: 100%;
	height: var(--base-px-50);
}

.option_row option {
	height: var(--base-px-10);
}
</style>
